export enum AppRoutes {
  Home = '/',
  Hidden = '/hidden',
  SpecificLocation = '/hidden/:locationId',
  SpecificMarker = '/hidden/:locationId/:markerId'
}
